import I18nTranslateSFC from "./I18nTranslate.vue";
export type { II18nTranslateProps } from "./props";
export const I18nTranslate = I18nTranslateSFC;
